import { isBefore, parseJSON } from 'date-fns'

export const downloadHasExpired = (download) =>
  download.expiresAt && isBefore(parseJSON(download.expiresAt), new Date())
